import SportPositionTypeGroups from "./SportPositionTypeGroups";
export default SportPositionTypeGroups;
